import {
    Checkbox as MuiCheckbox,
    FormControlLabel,
    FormGroup,
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import * as React from "react";

import { RelodeTheme } from "../styles";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            placementStart: {
                marginLeft: 0,
            },
            checkbox: {
                position: "relative",
                top: "3px",
            },
        }),
    { name: "RelodeCheckbox" }
);

interface Props {
    checked?: boolean;
    label?: React.ReactNode;
    value?: string | boolean;
    labelPlacement?: "bottom" | "top" | "end" | "start" | undefined;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    id: string;
    disabled?: boolean;
    color?: "primary" | "secondary" | "default";
}

export const Checkbox = (props: Props) => {
    const {
        checked,
        label,
        value,
        labelPlacement,
        onChange,
        id,
        disabled,
        color = "primary",
    } = props;
    const classes = useStyles({});

    return (
        <FormGroup row id={`${id}FormGroup`}>
            <FormControlLabel
                className={
                    labelPlacement === "start"
                        ? classes.placementStart
                        : undefined
                }
                control={
                    <MuiCheckbox
                        checked={checked || false}
                        onChange={onChange}
                        value={value}
                        className={classes.checkbox}
                        id={id}
                        disabled={disabled}
                        color={color}
                    />
                }
                label={label}
                labelPlacement={labelPlacement}
            />
        </FormGroup>
    );
};
